/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { LayoutSlot } from '@/components/layouts/LayoutSlot';
import { layoutItemWrapSX } from '@/components/layouts/styles/itemWrap';
import { layoutMainSX } from '@/components/layouts/styles/main';
import { Layout } from '@/data/types/Layout';
import { useTheme } from '@mui/material/styles';
import { Container, Grid, Stack } from '@mui/material';
import { FC } from 'react';

export const BrandCategoryLayout: FC<{ layout: Layout }> = ({ layout }) => {
	const {
		customDimensions: { layoutSpacing },
	} = useTheme();
	return layout ? (
		<>
			<LayoutSlot slot={layout.slots.header} />
				<Stack
					component="main"
					gap={layoutSpacing}
					sx={layoutMainSX(layout.slots.first?.length || 0)}
				>
					<Container component="section">
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.first} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={6} sm={3} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.second} /></Grid>
							<Grid item xs={6} sm={3} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.third} /></Grid>
							<Grid item xs={6} sm={3} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourth} /></Grid>
							<Grid item xs={6} sm={3} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifth} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.six} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seven} /></Grid>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eight} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nine} /></Grid>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.ten} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eleven} /></Grid>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twelve} /></Grid>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirteen} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fourteen} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.fifteen} /></Grid>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.sixteen} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.seventeen} /></Grid>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.eighteen} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.nineteen} /></Grid>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twenty} /></Grid>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyone} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentytwo} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentythree} /></Grid>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyfour} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyfive} /></Grid>
							<Grid item xs={12} sm={6} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentysix} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyseven} /></Grid>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentyeight} /></Grid>
							<Grid item xs={12} sm={4} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.twentynine} /></Grid>
						</Grid>
						<Grid container columnSpacing={layoutSpacing}>
							<Grid item xs={12} sm={12} pt={0} sx={layoutItemWrapSX}><LayoutSlot slot={layout.slots.thirty} /></Grid>
						</Grid>
					</Container>
				<LayoutSlot slot={layout.slots.footer} />
	    	</Stack>
		</>
	) : null;
};
